import { createFileRoute } from '@tanstack/react-router';
import { HealthPage } from '@/components/health';

export const Route = createFileRoute('/_authenticated/health')({
  component: HealthPage,
});
